import React from 'react'
import {withSearch} from '@elastic/react-search-ui'

import '@ongov/ontario-design-system-global-styles/dist/styles/css/compiled/ontario-theme.min.css'

import {SearchResetButton, CloseIconContainer, CloseIcon} from './styles'
import {icons} from '../../../theme'

const SearchResetButtonComponent = ({setSearchTerm, translation}) => {
  const emptyInputBar = () => {
    setSearchTerm('', {
      shouldClearFilters: false,
      refresh: false,
    })
  }

  return (
    <CloseIconContainer type="reset">
      <CloseIcon className="clear-input-svg" aria-hidden="true">
        {icons.ontarioCloseIconSVG}
      </CloseIcon>
      <SearchResetButton
        id="search-reset"
        aria-label={translation}
        onClick={emptyInputBar}
        type="reset"
        value=""
      />
    </CloseIconContainer>
  )
}

export default withSearch(({setSearchTerm}) => ({
  setSearchTerm,
}))(SearchResetButtonComponent)
